import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'oidc-react';
import { useDispatch } from 'react-redux';
import { setAuthState } from '../store/states/UserSlice';

export const Logout = () => {
  const { t } = useTranslation();

  const auth = useAuth();
  const dispatch = useDispatch();

  useEffect(() => {
    //logout from the oidc after redirect to the logout page
    auth.signOut();
    dispatch(setAuthState('logout'));
  }, []);

  return <h4> {t('messages.logoutMessage')} </h4>;
};
